<template>
  <div>
    <div class="filter">
      <div
        class="button"
        :class="{ blue: !man, green: man, grey: child }"
        @click="toggleValue('man')"
      >
        Uomo
      </div>
      <div
        class="button"
        :class="{ ocean: !child, green: child, grey: man }"
        @click="toggleValue('child')"
      >
        Bambino
      </div>
    </div>
    <div class="filterx">
      <v-select
        label="name"
        placeholder="Filtra per Marca"
        @input="filter"
        v-model="brand"
        value="name"
        :options="brands"
        :reduce="brand => brand.name"
      >
      </v-select>
      <v-select
        label="number"
        id="selNumber"
        placeholder="Filtra per Numero"
        @input="filter"
        v-model="number"
        :options="numbers"
      >
      </v-select>
    </div>
    <Shoe
      v-for="(shoe, index) in filteredShoes"
      :key="shoe._id"
      :shoe="shoe"
      :index="index"
    />
  </div>
</template>

<script>
import Shoe from "@/components/Shoe.vue";
import "vue-select/dist/vue-select.css";

export default {
  components: { Shoe },
  data: function() {
    return {
      shoes: null,
      manChild: null,
      brandFilter: null,
      filteredShoes: null,
      man: false,
      child: false,
      brand: null,
      number: null,
      numbers: []
    };
  },
  methods: {
    filter: function() {
      if (!this.man && !this.child) {
        this.manChild = this.shoes;
      } else if (this.man) {
        this.manChild = this.shoes.filter(shoe => shoe.sizes === "man");
      } else {
        this.manChild = this.shoes.filter(shoe => shoe.sizes === "child");
      }

      if(this.brand !== null) {
        sessionStorage.setItem('brand', this.brand);
        this.brandFilter = this.manChild.filter(shoe => shoe.brand === this.brand);
      } else {
        sessionStorage.removeItem('brand');
        this.brandFilter = this.manChild;
      }

      if(this.number !== null) {
        sessionStorage.setItem('number', this.number);
        this.number = parseFloat(this.number);
        this.filteredShoes = this.brandFilter
            .filter(shoe => {
              if(!shoe.measures.find(m => m.number === this.number)) {
                return false;
              } else {
                return shoe.measures.find(m => m.number === this.number).availability > 0;
              }
            });
      } else {
        sessionStorage.removeItem('number');
        this.filteredShoes = this.brandFilter;
      }
    },
    toggleValue: function(param) {
      if(param === 'man') {
        this.man = !this.man;
        this.child = false;
      } else {
        this.man = false;
        this.child = !this.child;
      }

      sessionStorage.setItem('man', this.man);
      sessionStorage.setItem('child', this.child);
      this.filter();
    },
  },
  computed: {
    brands: function() {
      return this.$store.state.brands;
    }
  },
  mounted: function() {

    for(let i = 32; i < 48; i += 0.5) {
      this.numbers.push(i);
    }

    console.log(this.numbers);

    this.shoes = this.$store.getters.shoes(this.$route.params.name);
    this.manChild = [...this.shoes];
    this.filteredShoes = [...this.shoes];
    console.log(sessionStorage);
    this.man = sessionStorage.getItem('man') == 'true';
    this.child = sessionStorage.getItem('child') == 'true';
    this.brand = sessionStorage.getItem('brand');
    this.number = sessionStorage.getItem('number');
    this.filter();
  }
};
</script>

<style scoped>
#selNumber{
  margin-top: 10px;
}

.filter {
  display: flex;
  margin: 40px 0 20px;
}

.button {
  width: 50%;
  font-size: 19px;
  padding: 10px;
}

.blue {
  background-color: #455ca7;
  color: white;
}

.ocean {
  background-color: #72aed9;
  color: white;
}

.green {
  background-color: #66b17d;
  color: white;
}

.grey {
  background-color: #a1a1a1;
  color: white;
}

.filterx {
  margin-bottom: 10px;
}
</style>
